import React from 'react';
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from 'react-router';
import { constants } from 'appConstants';

if (import.meta.env.MODE === 'production') {
  (async () => {
    const { init, reactRouterV7BrowserTracingIntegration, replayIntegration } = await import('@sentry/react');
    init({
      dsn: "https://d2ab131d8e81ab7cc8804a8b132d12e4@o933940.ingest.us.sentry.io/4509571895132160",
      tunnel: constants.errorMonitoringUrl,
      debug: false,
      sendDefaultPii: true,
      integrations: [
        reactRouterV7BrowserTracingIntegration({
          useEffect: React.useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
        }),
        replayIntegration(),
      ],
      tracesSampleRate: 0.2,
      tracePropagationTargets: ["localhost", /^https:\/\/testerly\.com\/api/],
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    });
  })();
}